import api from '../services/api';
import firebase from 'firebase/app';
import 'firebase/database';
import {toastr} from 'react-redux-toastr'
import io from 'socket.io-client';
import SocketClient from '../services/SocketClient';

import { 
    MODIFICA_EMAIL, 
    MODIFICA_SENHA, 
    MODIFICA_NOME, 
    MODIFICA_LOGIN, 
    LOADING,
    LOGIN_USUARIO_SUCESSO,
    LOGOUT,
    EXTENSION_AVAILABLE,
    VERIFICAR_AGENTE_CONECTADO,
    UPDATE_WAITING,
    UPDATE_COMPLETED,
    UPDATE_ABANDON,
    UPDATE_CONNECTED,
    ATUALIZA_AGENTES
} from './types';
import { push } from 'connected-react-router';


export const modificaEmail = (texto) => {
    return {
        type: MODIFICA_EMAIL,
        payload: texto
    }
}

export const modificaLogin = (texto) => {
    return {
        type: MODIFICA_LOGIN,
        payload: texto
    }
}

export const modificaSenha = (texto) => {
    return {
        type: MODIFICA_SENHA,
        payload: texto
    }
}

export const modificaNome = (texto) => {
    return {
        type: MODIFICA_NOME,
        payload: texto
    }
}
   

export const logarUsuario = ({ login, senha, server }) => {
    return async dispatch => {

        dispatch({ type: LOADING, payload: true });
        await localStorage.setItem('server', server)
        
        try {
            api.defaults.baseURL = server;
            const response = await api.post(`/api/login` , { login, senha });
            const { token } = response.data;

            await autenticarUsuario(dispatch, token);
            dispatch({ type: LOADING, payload: false });
            dispatch(push('/'));
        } catch (error) {
            dispatch({ type: LOADING, payload: false });
            if (error.response) {
                toastr.error('Error: '+error.response.status, error.response.data.message);
            } else {
                toastr.error('Error: Url solicitado não respondendo');
            }
        }
    }
}

export const recarregaUsuario = (token, path) => {
    return async dispatch => {
        await autenticarUsuario(dispatch, token);
        dispatch(push(path));
    }
}

export const autenticarUsuario = async (dispatch, token) => {
    let data = token.split('.');
    
    data = JSON.parse(atob(data[1]));
    const server = await localStorage.getItem('server');
    await localStorage.setItem('token', token);
    api.defaults.headers.Authorization = `Bearer ${token}`;

    // api.defaults.baseURL = '/api/';

    // firebase.database().ref(`/empresas/${data.empresa_uid}/users`)
    // .on("value", snapshot => {

    //     console.log(ATUALIZA_AGENTES,  snapshot.val());
    //     dispatch({ type: ATUALIZA_AGENTES, payload: snapshot.val() });
    // })

    dispatch({ type: LOGIN_USUARIO_SUCESSO, payload: { token, authenticated: true, ...data } });


    // Inicializa o SocketService (exemplo: token e URL do servidor)
    SocketClient.initialize(token, server);
    
    const socket = SocketClient.getSocket();
    // const socket = io(server, {
    //     auth: {
    //       token: token
    //     }
    // });

    // Evento emitido quando a conexão é estabelecida
    socket.on('connect', () => {
        console.log('Conectado ao servidor Socket.IO');
    });
    
    // Evento emitido quando a conexão é perdida
    socket.on('disconnect', () => {
        console.log('Conexão perdida com o servidor Socket.IO');
    });
    
    // Evento emitido quando o Socket.IO tenta reconectar
    socket.on('reconnecting', (attemptNumber) => {
        console.log(`Tentativa de reconexão: ${attemptNumber}`);
    });
    
    // Evento emitido quando a reconexão é bem-sucedida
    socket.on('reconnect', (attemptNumber) => {
        console.log(`Reconexão bem-sucedida após ${attemptNumber} tentativas`);
    });
    
    // Evento emitido quando todas as tentativas de reconexão falham
    socket.on('reconnect_failed', () => {
        console.log('Falha na reconexão após várias tentativas');
    });

    // client-side
    socket.on("connect_error", async (err) => {
        if (err && err.message === "Token invalid") {
            await localStorage.removeItem('token');
            dispatch({ type: LOGOUT });
            toastr.error('Error: 403 '+ err.message, err.data.content); 
        } else {
            console.error("Erro de conexão:", err.message);
            // Exibir uma mensagem de erro genérica para o usuário
            toastr.error('Erro de conexão', err.message);
        }
    });

    // QUANDO ENVIA UMA MENSAGEM DIRETO PELA SALA
    socket.on('message', payload => {

        //console.log('message',payload); // Exibe a mensagem recebida do servidor

        const event = payload.event

        switch (event) {
            case 'extensions_available':
                extensions_available(dispatch, data, payload.data)
                break;
            case 'change_user':
                change_user(dispatch, payload.data)
                break;
            case 'update_users':
                update_users(dispatch, payload.data)
                break;
            case 'update_queues_waiting':
                update_queues_waiting(dispatch, payload.data)
                break;

            case 'update_completed':
                update_completed(dispatch, payload.data)
                break;

            case 'update_abandon':
                update_abandon(dispatch, payload.data)
                break;

            case 'update_connected':
                update_connected(dispatch, payload.data)
                break;
        
            default:
                break;
        }
    });

    // QUANDO ENVIA UMA MENSAGEM DIRETO PARA O SOCKER.ID
    socket.on(data.c_agent_id, payload => {
        const event = payload.event
        switch (event) {
            case 'change_user':
                change_user(dispatch, payload.data)
                break;
        }
    });

}


const extensions_available = (dispatch, auth, data) => {
    
    //CASO SEJA RAMAIS FIXOS NAO FICAR OUVINDO
    if(!auth.extensionsAvailable) {
        dispatch({ type: EXTENSION_AVAILABLE, payload: data });
    } else {
        dispatch({ type: EXTENSION_AVAILABLE, payload: auth.extensionsAvailable });
    }

}
const change_user = (dispatch, data) => {
    dispatch({ type: VERIFICAR_AGENTE_CONECTADO, payload: data });
}
const update_users = (dispatch, data) => {
    dispatch({ type: ATUALIZA_AGENTES, payload: data });
}
const update_queues_waiting = (dispatch, data) => {
    dispatch({ type: UPDATE_WAITING, payload: data });
}

const update_completed = (dispatch, data) => {
    dispatch({ type: UPDATE_COMPLETED, payload: data });
}

const update_abandon = (dispatch, data) => {
    dispatch({ type: UPDATE_ABANDON, payload: data });
}

const update_connected = (dispatch, data) => {
    dispatch({ type: UPDATE_CONNECTED, payload: data });
}

export const logout = _ => {
    return async dispatch => {

        const socket = SocketClient.getSocket();
        socket.disconnect()
      
        await localStorage.removeItem('token');
        dispatch({ type: LOGOUT });
    }
}